import { observable } from 'mobx';

export type ChangeFeeOriginalMappingResponseArgs = {
  id?: number;
  change_fee_element_id?: number;
  change_fee_order_item_id?: number;
  change_fee_trace_id?: number;
  original_order_item_id?: number;
  original_trace_id?: number;
};

export type ChangeFeeOriginalMappingArgs = {
  id?: number;
  changeFeeElementId?: number;
  changeFeeOrderItemId?: number;
  changeFeeTraceId?: number;
  originalOrderItemId?: number;
  originalTraceId?: number;
};

export const convertChangeFeeOriginalMappingResponseToArgs = (
  response: ChangeFeeOriginalMappingResponseArgs
): ChangeFeeOriginalMappingArgs => {
  return {
    id: response.id,
    changeFeeElementId: response.change_fee_element_id,
    changeFeeOrderItemId: response.change_fee_order_item_id,
    changeFeeTraceId: response.change_fee_trace_id,
    originalOrderItemId: response.original_order_item_id,
    originalTraceId: response.original_trace_id
  };
};

export default class ChangeFeeOriginalMapping {
  @observable id?: number;
  @observable changeFeeElementId?: number;
  @observable changeFeeOrderItemId?: number;
  @observable changeFeeTraceId?: number;
  @observable originalOrderItemId?: number;
  @observable originalTraceId?: number;

  constructor(args: ChangeFeeOriginalMappingArgs = {}) {
    this.id = args.id;
    this.changeFeeElementId = args.changeFeeElementId;
    this.changeFeeOrderItemId = args.changeFeeOrderItemId;
    this.changeFeeTraceId = args.changeFeeTraceId;
    this.originalOrderItemId = args.originalOrderItemId;
    this.originalTraceId = args.originalTraceId;
  }

  get updateParams() {
    return {
      id: this.id,
      change_fee_element_id: this.changeFeeElementId,
      change_fee_order_item_id: this.changeFeeOrderItemId,
      change_fee_trace_id: this.changeFeeTraceId,
      original_order_item_id: this.originalOrderItemId,
      original_trace_id: this.originalTraceId
    };
  }
}
